var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1972_4039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 19.657V16.657C4.98906 16.4404 1.66406 12.9737 1.66406 8.7487C1.66406 4.38203 5.21406 0.832031 9.58073 0.832031C13.9474 0.832031 17.4974 4.38203 17.4974 8.7487C17.4974 12.8737 14.6307 17.0237 10.3557 19.082L9.16406 19.657ZM9.58073 2.4987C6.13073 2.4987 3.33073 5.2987 3.33073 8.7487C3.33073 12.1987 6.13073 14.9987 9.58073 14.9987H10.8307V16.9154C13.8641 14.9987 15.8307 11.8487 15.8307 8.7487C15.8307 5.2987 13.0307 2.4987 9.58073 2.4987ZM8.7474 12.082H10.4141V13.7487H8.7474V12.082ZM10.4141 10.832H8.7474C8.7474 8.1237 11.2474 8.33203 11.2474 6.66536C11.2474 5.7487 10.4974 4.9987 9.58073 4.9987C8.66406 4.9987 7.91406 5.7487 7.91406 6.66536H6.2474C6.2474 4.8237 7.73906 3.33203 9.58073 3.33203C11.4224 3.33203 12.9141 4.8237 12.9141 6.66536C12.9141 8.7487 10.4141 8.95703 10.4141 10.832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1972_4039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.bdf90063f889de7e144a4d0444998514.svg";
export { ForwardRef as ReactComponent };